import React, {useContext, useEffect, useState} from "react"
import Row from "@amzn/meridian/row";
import Alert from "@amzn/meridian/alert";
import {DWP_FILE_UPLOAD_SOURCE} from "../util/Constants";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {PickContext} from "../pickStatus/context/PickContext";
import {DWPFileContext} from "../fileupload/context/DWPUploadContext";
import {injectIntl} from "react-intl";
import enjson from '../../il8n/locales/en.json';

const NoStagingLocationBanner = (props) => {

    const {configViewModel} = useContext(CapabilityContext)
    const {viewModel} = useContext(PickContext);
    const {viewModelDWP} = useContext(DWPFileContext);
    const [userClosedBanner, setUserClosedBanner] = useState(false);
    const [showBanner, setShowBanner] = useState(false);
    const [bannerText, setBannerText] = useState("");
    const bannerType = "error";

    useEffect(() => {
        // if we don't have the sufficient information
        if (!viewModel.routeList || !viewModel.routeList.length ||
            !viewModelDWP.creationTime ||
            configViewModel.stationConfig.missingStagingLocationAlertThreshold === undefined) {
            return;
        }
        // using 10% as the default invalidStagingLocationThreshold
        const threshold = viewModel.routeList.length * configViewModel.stationConfig.missingStagingLocationAlertThreshold / 100;
        // check if any doesn't have staging location
        const noStagingLocationCount = viewModel.routeList.filter(route => !route.stagingLocation).length;
        if (noStagingLocationCount > threshold) {
            const messageId = getNoStagingLocationErrorString(viewModelDWP.uploadSource);
            setShowBanner(true);
            setBannerText(props.intl.formatMessage({id: messageId, defaultMessage: enjson[messageId]}, {
                count: noStagingLocationCount,
                creationTime: viewModelDWP.creationTime
            }));
        } else {
            setShowBanner(false);
        }
    }, [viewModelDWP, viewModel.routeList, configViewModel.stationConfig]);

    const getNoStagingLocationErrorString = (uploadSource) => {
        switch (uploadSource) {
            case DWP_FILE_UPLOAD_SOURCE.MANUAL:
                return 'pick.noStagingLocationErrorManual';
            case DWP_FILE_UPLOAD_SOURCE.AUTO:
                return 'pick.noStagingLocationErrorAuto';
            default:
                return 'pick.noStagingLocationError';
        }
    }

    return (
        <div>
            {showBanner && !userClosedBanner &&
            <Row widths={["grid-12"]} spacingInset="medium none none none" alignmentHorizontal="center">
                <Alert size="medium" type={bannerType} onClose={() => setUserClosedBanner(true)}>
                    {bannerText}
                </Alert>
            </Row>
            }
        </div>
    )
}

export default injectIntl(NoStagingLocationBanner);



// WEBPACK FOOTER //
// ./src/components/outboundBanners/NoStagingLocationBanner.js